<template>
    <v-container>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate
                                 size="64"></v-progress-circular>
        </v-overlay>
        <v-row>
            <v-col>
                <v-card>
                    <v-card-title class="primary">
                        <v-toolbar-title style="color: white;">
                            Entrega de Documentación
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-icon color="white">mdi-file-document-multiple-outline</v-icon>
                    </v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col cols="12" md="6" offset-md="3">
                                <v-list>
                                    <v-list-item>
                                        <v-list-item-content>
                                            <v-list-item-title style="color: black !important;">Reporte en trámite:</v-list-item-title>
                                            <v-list-item-subtitle style="color: black !important;"><h6>{{reporte.nrreporte}}-{{reporte.svindice}}</h6></v-list-item-subtitle>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-list-item v-if="datosReporte[0]">
                                        <v-list-item-content>
                                            <v-list-item-title style="color: black !important;">Asistencia:</v-list-item-title>
                                            <v-list-item-subtitle style="color: black !important;"><h6>{{datosReporte[0].asistencia}}</h6></v-list-item-subtitle>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-list-item v-if="datosReporte[0]">
                                        <v-list-item-content>
                                            <v-list-item-title style="color: black !important;">Abogado:</v-list-item-title>
                                            <v-list-item-subtitle style="color: black !important;"><h6>{{datosReporte[0].prclave}} - {{datosReporte[0].prnombre}}</h6></v-list-item-subtitle>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-list-item>
                                        <v-list-item-content>
                                            <v-list-item-title style="color: black !important;">Fecha de Conclusión:</v-list-item-title>
                                            <v-list-item-subtitle style="color: black !important;"><h6>{{reporte.svfhconclusion}}</h6></v-list-item-subtitle>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>
                            </v-col>
                        </v-row>
                        <v-row class="ms-2">
                            <v-col cols="12" md="6" offset-md="3" class="mt-2">
                                <v-list-item-title class="typo__label" style="color: black !important;">Fecha:</v-list-item-title>
                                <v-menu ref="menu1" style="z-index: 200; position: absolute;"
                                        v-model="menu1"
                                        :close-on-content-click="false"
                                        transition="scale-transition"
                                        offset-y
                                        max-width="290px"
                                        min-width="auto">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field v-model="dateFormatted"
                                                      outlined
                                                      readonly
                                                      v-bind="attrs"
                                                      @blur="date = parseDate(dateFormatted)"
                                                      v-on="on"></v-text-field>
                                    </template>
                                    <v-date-picker v-model="date"
                                                   locale="es-mx"
                                                   :max="maxfecha"
                                                   :min="mindate"
                                                   @input="menu1 = false"></v-date-picker>
                                </v-menu>
                            </v-col>
                        </v-row>
                        <v-row class="ms-2">
                            <v-col cols="12" md="6" offset-md="3" class="mt-2">
                                <v-list-item-title class="typo__label" style="color: black !important;">Enviar documentación a:</v-list-item-title>
                                <multiselect placeholder="Seleccione un valor" v-model="selected" :options="usuario"
                                             label="sunombre" track-by="suemail" deselect-label="No se puede remover el valor seleccionado"
                                             selected-label="Seleccionado" select-label="Seleccionar valor" :class="colors" @input="addTag()">
                                </multiselect>
                                <span style="color: red;" v-if="validaMulti">Selección requerida</span>
                            </v-col>
                        </v-row>
                        <v-row class="ms-2">
                            <v-col cols="12" md="6" offset-md="3" class="mt-2">
                                <v-list-item-title class="typo__label" style="color: black !important;">Observaciones:</v-list-item-title>
                                <v-form ref="frm" v-model="valid" lazy-validation>
                                    <v-textarea :counter="500"
                                                :rules="rulestextarea"
                                                outlined
                                                v-model="comentarios"
                                                required
                                                name="input-7-4"></v-textarea>
                                </v-form>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" class="text-center">
                                <v-btn class="ma-2"
                                       color="primary"
                                       @click="Guardar()">
                                    Guardar
                                    <template v-slot:loader>
                                        <span>Loading...</span>
                                    </template>
                                </v-btn>
                                <v-btn class="ma-2" @click="Limpiar()">
                                    Limpiar
                                </v-btn>
                                <v-btn class="ma-2" color="error" @click="Regresar()">
                                    Regresar
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
    
</template>
<script>
    import { mapActions, mapState } from 'vuex';
    import pago from '@/services/TramitePago/TramitePago.Service.js';
    import MetodosGenerales from '@/utils/metodosgenerales.vue.js';

    export default {
        title() {
            return this.$route.meta.title
        },
        data: vm => ({
            usuario: [],
            selected: '',
            colors: '',
            validaMulti: false,
            valid: true,
            maxfecha: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10), 
            date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
            dateFormatted: vm.formatDate((new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)),
            menu1: false,
            comentarios: '',
            reporte: [],
            datosReporte: [],
            rulestextarea: [
                v => !!v || 'Campo requerido',
                v => {
                    if (v == null) {
                        return true
                    }
                    else {
                        if (v.length < 12) {
                            return 'Mínimo 12 Carácteres'
                        }
                        else if (v.length > 500) {
                            return 'Máximo 500 Carácteres'
                        }
                        else
                            return true
                    }
                },
            ],
            npid: 0,
            mindate: '',
            overlay: false,
        }),
        computed: {
            ...mapState([
                "domain",
                "informationPage",
                "paginacion",
                "permission",
                "user"
            ]),
            computedDateFormatted() {
                return this.formatDate(this.date)
            },
        },
        watch: {
            date(val) {
                this.dateFormatted = this.formatDate(this.date)
            },
        },
        methods: {
            async ObtenerDatosReporte(){
                let formdata = new FormData();
                formdata.append("reporte", this.reporte.nrreporte);
                formdata.append("indice", this.reporte.svindice);
                await pago.ObtenerDatosReporte(this, formdata).then(data =>{
                    this.datosReporte = data;
                    this.npid = data[0].npid;
                    this.overlay = false;
                });
            },
            ObtenerUsuario() {
                let formData = new FormData();
                formData.append("reporte", this.reporte.nrreporte);
                formData.append("indice", this.reporte.svindice);
                pago.ObtenerUsuario(this, formData).then(data => {
                    this.usuario = data;
                });
            },
            addTag() {

                if (this.selected !== "" || this.selected !== null) {
                    this.colors = '';
                    this.validaMulti = false;
                }
            },
            async Guardar() {
                let permiso = false;
                await MetodosGenerales.verificarPermisoSolo(this.domain.domainNameForApi, "VerificarPermiso", '339').then(response => {
                    if (response.data.length > 0) {
                        permiso = true;
                    }
                });
                let uslogin = '';
                
                if (this.selected == '' || this.selected === null) {
                    this.colors = 'border: 1px solid red;';
                    this.validaMulti = true;
                }
                else {
                    this.validaMulti = false;
                    uslogin = this.selected.suemail.split('@');
                }
                if (this.reporte.svfhconclusion == "" && permiso == false) {
                    this.$swal({
                        title: "Cargando...",
                        html: "No se pueden enviar la documentación del reporte a Revisión de Contraloría porque no tiene fecha de conclusión",
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                    });
                }
                else {
                    this.comentarios = this.comentarios.trim();
                    this.comentarios = this.comentarios.replace(/\s*$/, "");

                    if (this.$refs.frm.validate() && this.comentarios.length >= 12 && this.validaMulti == false) {
                        let formData = new FormData();
                        if (this.reporte.svfhconclusion != '')
                            formData.append("estatus", 56);
                        else
                            formData.append("estatus", 52);
                        formData.append("reporte", this.reporte.nrreporte);
                        formData.append("indice", this.reporte.svindice);
                        formData.append("fecha", this.date);
                        formData.append("obs", this.comentarios);
                        formData.append("usloginenvio", uslogin[0]);
                        this.$swal({
                            title: "Guardando la solicitud...",
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                        });
                        this.$swal.showLoading();
                        pago.GuardarEnvioDocto(this, formData).then(data => {
                            if (data[0].success == "true") {  
                                this.$swal({
                                    position: "center",
                                    icon: "success",
                                    title: "Éxito",
                                    text: "Los datos se guardaron correctamente",
                                    allowOutsideClick: false,
                                    allowEscapeKey: false,
                                    showConfirmButton: true,
                                    timer: 2000,
                                    confirmButtonText: "Aceptar",
                                }).then(() => {
                                    this.$router.push({ name: `ReportesPendientes` });
                                });
                            }
                            else {
                                this.$swal({
                                    position: "center",
                                    icon: "error",
                                    title: "Error",
                                    text: "No se pudo guardar los datos, por favor intente de nuevo más tarde, si el problema persiste pónganse en contacto con el equipo de asistencia técnica",
                                    allowOutsideClick: false,
                                    allowEscapeKey: false,
                                    showConfirmButton: true,
                                    confirmButtonText: "Ok!",
                                });
                            }
                        });
                    }
                }
            },
            Limpiar() {
                this.selected = '';
                this.validaMulti = false;
                this.comentarios = '';
                this.dateFormatted = this.formatDate((new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10));
            },
            Regresar() {
                this.$router.push({ name: 'ReportesPendientes' });
            },
            formatDate(date) {
                if (!date) return null

                const [year, month, day] = date.split('-')
                return `${day}/${month}/${year}`
            },
            parseDate(date) {
                if (!date) return null

                const [day, month, year] = date.split('/')
                return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
            },
            ObtenerFecha() {
                let formdata = new FormData();
                formdata.append("npid", this.npid);
                pago.ObtenerFecha(this, formdata).then(data => {
                    this.mindate = this.parseDate(data[0].npfhenvio);
                });
            },
        },
        async mounted() {
            this.overlay = true;
            this.reporte = await MetodosGenerales.obtenerSessionReporte('reporte');

            await this.ObtenerDatosReporte();
            this.ObtenerUsuario();
            
        },
        async created() {
            this.overlay = true;
            this.datosReporte = [];
            
            //this.reporte = await MetodosGenerales.obtenerSessionReporte('reporte');

            //await this.ObtenerDatosReporte();
            this.ObtenerFecha();
        }
    }
</script>
<style>
    .multiselect--active {
        z-index: 9999 !important;
    }

    .border-error {
        border-color: red;
    }

    .dz-preview {
        width: 150px;
    }
</style>